<template>
    <div :id="'radio--' + component_id">
        <div v-show="options_loaded && passed_filter && panel_required">
            <div class="radiooption stylesoption" v-if="!loading" :data-designer-component-id="component_id">
                <span> {{ title }} </span>
                <span v-for="option in filtered_option_list"><label><input type="radio" v-model="localTarget"
                                                                           :name="'radio_' + component_id"
                                                                           :value="option.value"/> {{ option.label }}</label></span>
            </div>
            <div v-if="loading">
                <p>Loading Options</p>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import RadioQuestion from "./mixin/RadioQuestion.vue";

    export default {
        mixins: [
            RadioQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Hinge Bolts: ';
                }
            },
            component_id: {
                default(){
                    return 'hardware_hinge_bolts';
                }
            },
            hardwareColour: {
                required: true
            },
            hardwareHinge: {
                required: true
            },
            securedByDesign: {
                required: true
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.hardwareHinge, this.hardwareColour, this.securedByDesign);
            },
            url(){
                return '/api/options/' + this.fabricator + '/hinge-bolts?hardware_hinge=' + this.hardwareHinge + '&hardware_colour=' + this.hardwareColour + '&secured_by_design=' + this.securedByDesign;
            },
            cache_key(){
                return '_' + this.hardwareHinge + '_' + this.hardwareColour + '_' + this.securedByDesign;
            },
            panel_required(){
                return this.filtered_option_list.length > 1;
            }
        },
        watch: {
            'hardwareColour': function (val, oldVal) {
                this.update_options();
            },
            'hardwareHinge': function (val, oldVal) {
                this.update_options();
            },
            'securedByDesign': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
